import CloseIcon from "@mui/icons-material/Close";
import { Box, Drawer, Fab, Tab, Tabs, Tooltip } from "@mui/material";
import { SyntheticEvent, useContext, useState } from "react";
import { DashboardContext } from "../../../providers/Dashboard";
import { isCurrentColorModeDark } from "../../../providers/Theme";
import Viewer360 from "../360";
import Map from "../Map";
import Media from "../Media";
import { Container } from "./styles";

type DrawerTabs = "map" | "360" | "media";

interface SideDrawerProps {
  showCloseCaracterizacao?: boolean;
}

export default function SideDrawer({ showCloseCaracterizacao = false }: SideDrawerProps) {
  const { metadata } = useContext(DashboardContext);
  const [drawerTab, setDrawerTab] = useState<DrawerTabs>("map");

  function handleChange(_event: SyntheticEvent, newValue: DrawerTabs) {
    setDrawerTab(newValue);
  }

  function handleCloseCaracterizacao() {
    window.opener?.focus();
    window.close();
  }

  const tabSx = {
    "&.Mui-selected": isCurrentColorModeDark()
      ? {
          color: "primary.contrastText",
        }
      : {},
    "&:hover": isCurrentColorModeDark()
      ? {
          color: "primary.contrastText",
          opacity: 1,
        }
      : {},
  };

  return (
    <Drawer
      variant="persistent"
      anchor="right"
      hideBackdrop
      open={metadata.drawer}
      sx={{
        width: "30vw",
        minWidth: "30vw",
      }}
    >
      <Container>
        <Box>
          <Tabs
            variant="fullWidth"
            value={drawerTab}
            onChange={handleChange}
            sx={{
              height: "50px",
            }}
            TabIndicatorProps={{
              style: {
                backgroundColor: "#009c66",
              },
            }}
          >
            <Tab sx={tabSx} label={"Mapa"} value={"map"} />
            <Tab sx={tabSx} label={"360"} value={"360"} />
            <Tab sx={tabSx} label={"Mídias"} value={"media"} />
          </Tabs>

          {drawerTab === "map" && <Map />}
          {drawerTab === "360" && <Viewer360 />}
          {drawerTab === "media" && <Media />}
        </Box>
        {showCloseCaracterizacao && (
          <Box
            sx={{
              position: "absolute",
              bottom: 15,
              left: 15,
              zIndex: 1,
            }}
          >
            <Tooltip title="Fechar caracterização">
              <Fab size="small" onClick={handleCloseCaracterizacao} color="primary" aria-label="Fechar caracterização">
                <CloseIcon />
              </Fab>
            </Tooltip>
          </Box>
        )}
      </Container>
    </Drawer>
  );
}
